<div class="story-slider-row story-slider-fixed">
  <div class="story-slider-box">
    <div
      class="story-slider-item"
      *ngIf="this._UserHelper?.favoriedMatches?.length > 0"
      (click)="liveFavEnabled()"
      [ngClass]="{ selected: this._DataHelper.liveFavoriteButtonStatus }">
      <div class="story-slider-icon-count">
        <image-loader-utils url="star" extraClasses="story-slider-icon slidermenusvg favorited"></image-loader-utils>
        <div class="story-slider-count">
          {{ this._UserHelper.favoriedMatches.length }}
        </div>
      </div>
      <div class="story-slider-sport-name">{{ 'Favourites' | t }}</div>
    </div>
    <div class="story-slider-item" *ngFor="let storyItem of listArray" [ngClass]="{ selected: storyItem.selected }" (click)="selectStoryItemForB3000(storyItem)">
      <div class="story-slider-icon-count">
        <image-loader-utils
          [url]="this.sportsSvgList[storyItem.sportId]?.svgKey"
          [shared]="('product' | getEnv) !== 't90'"
          extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>
        <div class="story-slider-count" *ngIf="storyItem.count != null && storyItem.count != 0">
          {{ storyItem.count }}
        </div>
      </div>
      <div class="story-slider-sport-name">
        {{ storyItem.sportName }}
      </div>
    </div>
  </div>
</div>
